module.exports = __webpack_public_path__ + "static/Raphael_CLB_alt-c3ecaaca45e75d6e2ccc3e1aea2cfee5.webp";